/**
 * Created by anatoly on 01.04.2026
 */

ShowVictoryWindow = function (callback, rewardsList) {
    const player = new ActionPlayer([
        (f) => {
            new VictoryWindow(rewardsList);
            cleverapps.focusManager.onceNoWindowsListener = f;
        },

        (f, stop) => {
            if (this.game.level.isRegular() && cleverapps.knockoutGame.rumble.outcome === Rumble.OUTCOME_UNKNOWN) {
                this.game.boatswain.setIntent(Boatswain.NEXT_INTENT);
                rewardsList.receiveRewards(f);

                return;
            }

            stop();
        },

        LeaguesUpgradeAction.bind(this),
        StickersRewardAction.bind(this)
    ]);

    player.onFailure(callback);
    player.play(callback);
};